import { MONITORING_STATUS, MONITORING_STATUS_TITLE } from '@app/api/constants'
import { TAG_TYPE } from '@app/constants/tag'

import type { ObjectValuesType, TagStatus } from '@app/types'

// TODO возможно есть смысл сделать универсальным для всех статусов, но тогда необходимо понимать весь список статусов
export const getTagConfigMonitoringStatus = (status: ObjectValuesType<typeof MONITORING_STATUS>): TagStatus => {
  return {
    label: MONITORING_STATUS_TITLE[status],
    value: status,
    type: getTagType(status)
  }
}

const getTagType = (status: ObjectValuesType<typeof MONITORING_STATUS>): ObjectValuesType<typeof TAG_TYPE> => {
  if (status === MONITORING_STATUS.APPROVED) {
    return TAG_TYPE.success
  }

  if (status === MONITORING_STATUS.NOT_APPROVED) {
    return TAG_TYPE.danger
  }

  return TAG_TYPE.primary
}
